
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pengelolaan-kinerja-saya/konfirmasi-profil",
      function () {
        return require("private-next-pages/pengelolaan-kinerja-saya/konfirmasi-profil.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pengelolaan-kinerja-saya/konfirmasi-profil"])
      });
    }
  